// TaskItem に表示するカスタム列の設定をプロジェクト（リスト）ごとに localStorage へ保存する。
// 同じブラウザ・同じユーザーでのみ有効な「ローカル設定」として扱う。

const STORAGE_PREFIX = "taskItemCustomCols";

/** プロジェクトごとのストレージキーを生成する */
function buildKey(honbuId: number, roomId: number, listId: string): string {
  return `${STORAGE_PREFIX}_${honbuId}_${roomId}_${listId}`;
}

/**
 * TaskItem に表示するカスタム列ID（表示順）を読み込む。
 * 未設定・不正な場合は空配列を返す。
 */
export function loadVisibleCustomColumnIds(
  honbuId: number,
  roomId: number,
  listId: string | null,
): number[] {
  if (!listId || listId === "0") return [];
  try {
    const raw = localStorage.getItem(buildKey(honbuId, roomId, listId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    // 数値のみに正規化（順番は保持する）
    return parsed
      .map((v) => Number(v))
      .filter((n) => Number.isInteger(n) && n > 0);
  } catch {
    return [];
  }
}

/** TaskItem に表示するカスタム列ID（表示順）を保存する */
export function saveVisibleCustomColumnIds(
  honbuId: number,
  roomId: number,
  listId: string | null,
  columnIds: number[],
): void {
  if (!listId || listId === "0") return;
  try {
    localStorage.setItem(
      buildKey(honbuId, roomId, listId),
      JSON.stringify(columnIds),
    );
  } catch {
    // localStorage が使用不可な場合は無視する
  }
}
